import { UseFormRegisterReturn } from 'react-hook-form';
import { useState } from 'react';
import classnames from 'classnames';

import { isOverlappedByHeaderOrNavBtns } from '../../utils/ux.util';
import { RadioStyle } from './radio-style';

export interface IRadioProps {
  id: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  message?: string;
  errorMessage?: string;
  tooltip?: string;
  className?: string;
  onBlur?: any;
  onFocus?: any;
  onKeyDown?: any;
  value?: string | number;
  name?: string;
  label?: string;
  active: boolean;
  register?: UseFormRegisterReturn;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.MutableRefObject<HTMLInputElement>;
  dataCy?: string;
}

const Radio: React.FC<IRadioProps> = (props: IRadioProps) => {
  const {
    active,
    register,
    onClick,
    dataCy,
    id,
    inputRef,
    disabled,
    required,
    label,
    className,
    error,
    onChange,
    onFocus,
    onKeyDown,
  } = props;

  const [value, setValue] = useState<string>('');

  const handleChange = (ev: any) => {
    if (onChange) {
      onChange(ev);
    } else if (props.value === undefined) {
      setValue(ev.target.value);
    }
  };

  const { ref, ...registerFiltered } = register || {};
  return (
    <RadioStyle
      // {...props}
      className={classnames(className || '', {
        error: !!error,
        disabled: !!disabled,
        required: !!required,
      })}
      ref={ref}
      tabIndex={0}
      id={(id || '') + '-container'}
      data-cy={dataCy}
      onFocus={(event) => {
        isOverlappedByHeaderOrNavBtns(event.target);
      }}
    >
      <div className={classnames('radio-option', { active })}>
        <input
          type="radio"
          value={value}
          checked={true}
          ref={inputRef}
          disabled={disabled}
          required={required}
          onClick={onClick ?? (() => {})}
          onChange={(ev: any) => handleChange(ev)}
          onFocus={(ev: any) => onFocus?.(ev)}
          // onBlur={(ev: any) => props.onBlur && props.onBlur(ev)}
          onKeyDown={(ev: any) => onKeyDown?.(ev)}
          {...(register
            ? {
                ...registerFiltered,
                // onChange: (e) => {
                //   return onChange ? onChange(e) : register.onChange(e);
                // },
              }
            : {})}
          // value={props.value}
          id={id}
        />
        <label htmlFor={id}>
          <div className="radio-item">
            <div className="radio-item__circle" />
          </div>
          {label && <div className="radio-label">{label}</div>}
        </label>
      </div>
    </RadioStyle>
  );
};

export default Radio;
